module.exports = __webpack_public_path__ + "static/media/mobile.4783fab8.png";